import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { MissionVision } from "@/components/MissionVision";
import { Serve } from "@/components/Serve";
import { Give } from "@/components/Give";
import { Contact } from "@/components/Contact";

export default function Landing() {
  return (
    <main>
      <Hero />
      <MissionVision />
      <About />
      <Serve />
      <Give />
      <Contact />
    </main>
  );
}
